<template>
<div id="pageTable">
    <v-container grid-list-xl fluid>
        <v-card>
            <v-layout class="d-flex flex-lg-row flex-md-column flex-sm-column" wrap pa-3>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-toolbar-title>Tỷ giá - phí</v-toolbar-title>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.Currency" :decimal="0" label="Tỷ giá" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.ExchangeRevenue" :decimal="0" label="Lãi tỷ giá" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.VoucherAmount" :decimal="0" label="Voucher khách mới" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.MinFeeBuy" :decimal="0" label="Phí mua tối thiểu" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input v-model="configuration.MinFeePack" :decimal="1" label="Phí đóng gỗ tối thiểu 1 kiện (¥)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <v-text-field type="number" v-model="configuration.OrderCompleteDate" label="Số ngày tự động hoàn thành đơn" class="input-group--focused"></v-text-field>
                                </v-flex>
                                </v-layout>
                            <v-layout row wrap>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input :decimal="0" v-model="configuration.Density" label="Tỷ trọng cân nặng" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg6 md6 sm12>
                                    <h-currency-input :decimal="0" v-model="configuration.MaxDebt" label="Công nợ tôi đa" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
                <v-flex lg12 md12 sm12>
                    <v-layout row wrap>
                        <v-toolbar flat color="blue-grey" dark>
                            <v-tooltip bottom color="primary">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-toolbar-title v-bind="attrs"  v-on="on">Tỷ lệ hoa hồng nhân viên <i class="fa fa-question-circle" aria-hidden="true"></i></v-toolbar-title>
                                </template>
                                <span>
                                    <ul>
                                        <li>Khách mới (đăng ký 120 ngày)</li>
                                        <li>Khách cũ (đăng ký 150 ngày)</li>
                                        <li>Khách trung thành (đăng ký 150 ngày)</li>
                                        <li>Doanh thu = tiền mặc cả được</li>
                                        <li>Doanh thu Order = Phí dịch vụ của đơn mua hộ</li>
                                        <li>Doanh thu cước VCQT Order = Phí cân nặng đơn mua hộ</li>
                                        <li>Doanh thu cước VCQT Ký gửi = Phí cân nặng đơn ký gửi</li>
                                    </ul>
                                </span>
                            </v-tooltip>
                        </v-toolbar>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.RevenueCommissionRate" label="Hoa hồng chênh lệch doanh thu (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.OrderCommissionNewRate" label="Hoa hồng doanh thu Order - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.OrderCommissionMidRate" label="Hoa hồng doanh thu Order - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.OrderCommissionOldRate" label="Hoa hồng doanh thu Order - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.OrderFeeCommissionNewRate" label="Hoa hồng cước VCQT Order - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.OrderFeeCommissionMidRate" label="Hoa hồng cước VCQT Order - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.OrderFeeCommissionOldRate" label="Hoa hồng cước VCQT Order - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.DepositFeeCommissionNewRate" label="Hoa hồng cước VCQT Ký gửi - Khách mới (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.DepositFeeCommissionMidRate" label="Hoa hồng cước VCQT Ký gửi - Khách cũ (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                                <v-flex lg4 md4 sm12>
                                    <h-currency-input :decimal="1" v-model="configuration.DepositFeeCommissionOldRate" label="Hoa hồng cước VCQT Ký gửi - Trung thành (%)" class="input-group--focused"></h-currency-input>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-card>
    </v-container>
</div>
</template>

<script>
import {
    mapState
} from "vuex";
export default {
    computed: {
        ...mapState({
            loading: state => state.configuration.loading,
            configuration: state => state.configuration.selected
        })
    },
    methods: {
        refreshData() {
            this.$store.dispatch("configuration/getDetail", 1);
        },
        saveData() {
            this.$store.dispatch("configuration/setDetail", {
                data: this.configuration,
                id: this.configuration.ID
            });
        },
    },
    mounted() {
        this.refreshData();
        this.$root.$emit('REQUEST_ROOT_OPTION', {});
        this.$root.$on("REQUEST_SAVE_DATA", this.saveData);
        if (this.$route.query.uid && this.$route.query.uid !== '') {
            this.configuration.UID = Number(this.$route.query.uid);
        }
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_SAVE_DATA", this.saveData);
    },
};
</script>

<style>
</style>
